
import type { FetchResult } from 'apollo-link'
import { defineComponent } from 'vue'

import DowngradeToFreePlanMutation from '~/apollo/mutations/owner/downgradeToFreePlan.gql'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import type { DowngradeToFreePlanMutation as DowngradeToFreePlanMutationType } from '~/types/types'

export default defineComponent({
  name: 'DowngradeToOpenSourceLink',

  mixins: [OwnerDetailMixin],

  data() {
    return {
      isDowngrading: false,
      showConfirmDialog: false
    }
  },

  methods: {
    async downgradeToFreePlan(close?: () => void) {
      if (this.isDowngrading || !this.owner?.id) return

      this.isDowngrading = true
      try {
        const result: FetchResult<DowngradeToFreePlanMutationType> =
          await this.$applyGraphqlMutation(DowngradeToFreePlanMutation, {
            ownerId: this.owner.id
          })

        const payload = result.data?.downgradeToFreePlan
        if (payload?.error) {
          this.$toast.danger(payload.error)
          this.isDowngrading = false
        } else {
          if (close) close()
          window.location.reload()
        }
      } catch (e) {
        this.$logErrorAndToast(e as Error, 'Failed to downgrade plan. Please try again.')
        this.isDowngrading = false
      }
    }
  }
})
